import { Component, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { SearchToolService } from './service/search-tool.service';
import { searchInterface } from 'src/app/util/interfaces/search';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { faList, faSearch, faSortDown, faSortUp, faSquare } from '@fortawesome/free-solid-svg-icons';
import { GlobalService } from 'src/app/services/global/global.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { MspTableService } from 'src/app/page_component_item/msp-table/service/msp-table.service';
import { HomePageService } from '../request/home-page/data/home-page.service';
import { forkJoin, Subscription } from 'rxjs';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-search-tool',
	templateUrl: './search-tool.component.html',
	styleUrls: ['./search-tool.component.scss'],
})
export class SearchToolComponent implements OnInit {
	icons = {
		faSearch: faSearch,
		faSortDown: faSortDown,
		faSortUp: faSortUp,
	};

	labels: LabelsInterface = {
		lbl_min_char_search: 'Search must be at least 4 characters',
		lbl_rep_custom_arquivo_nao_encontrado: 'Archive not found',
		lbl_geral_nao_encontrado: 'Not found',
		lbl_procurando_arquivos: 'Searching archives',
		lbl_geral_resultados: 'Results',
		lbl_seach_arquivos_encontrados: 'files found',
		lbl_geral_chamado: 'Requests',
		lbl_geral_titulo: 'Title',
		lbl_nothing_was_found: "We couldn't found nothing about",
		lbl_here_some_results_for: 'Here are some results for',
		lbl_geral_descricao: 'Description',
		lbl_geral_identificacao: 'Identification',
		lbl_security_nenhum_registro: '',
		lbl_geral_summary: '',
		lbl_geral_status: '',
		lbl_geral_grupo: '',
		lbl_asset_tipo_ci: '',
		lbl_resultados_encontrados: '',
		lbl_geral_competencia: '',
		lbl_geral_natureza: '',
		lbl_geral_topico: '',
	};

	constructor(
		private ActivatedRoute: ActivatedRoute,
		private SearchToolService: SearchToolService,
		private LabelsService: LabelsService,
		private Router: Router,
		private NotificationService: NotificationService,
		private MspTableService: MspTableService,
		private HomePageService: HomePageService
	) {
		this.Router.routeReuseStrategy.shouldReuseRoute = () => false;
	}

	kbHeader: mspTableHeaderI[] = [];
	requestHeader: mspTableHeaderI[] = [];
	cmdbHeader: mspTableHeaderI[] = [];

	isLoadingSearchtool = true;
	isLoadingPages = true;
	isLoadingLabels = true;
	isLoadingAvailableViewItems = true;
	isLoadingNextPage = false;

	searchText = '';
	searchReq: Subscription;
	selectedSearchType: string;
	searchI: searchInterface = {
		request: [],
		kb: [],
		cmdb: [],
	};
	selectedPage = 1;
	itemsPerType: { request: number; kb: number; cmdb: number } = {
		cmdb: 0,
		request: 0,
		kb: 0,
	};
	itemsPerPage = this.MspTableService.getTableConfig('itemsPerPage');
	routerLinkType = {
		request: '/request/:id',
		kb: '/knowledgebase/read/:id',
		cmdb: '/cmdb/ci/:id',
	};

	sortedBy = 'id';
	sortDown = false;

	notFound = false;

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;

			this.requestHeader = [
				{ name: 'id', value: 'ID', colType: 'text' },
				{ name: 'summary', value: this.labels.lbl_geral_summary, colType: 'text' },
				{ name: 'solution_area', value: this.labels.lbl_geral_grupo, colType: 'text' },
				{ name: 'scope', value: this.labels.lbl_geral_competencia, colType: 'text' },
				{ name: 'category', value: this.labels.lbl_geral_natureza, colType: 'text' },
				{ name: 'topic', value: this.labels.lbl_geral_topico, colType: 'text' },
			];
			this.kbHeader = [
				{ name: 'id', value: 'ID', colType: 'text' },
				{ name: 'summary', value: this.labels.lbl_geral_summary, colType: 'text' },
				{ name: 'solution_area', value: this.labels.lbl_geral_grupo, colType: 'text' },
			];
			this.cmdbHeader = [
				{ name: 'id', value: 'ID', colType: 'text' },
				{ name: 'identification', value: this.labels.lbl_geral_identificacao, colType: 'text' },
			];

			this.isLoadingLabels = false;
		});

		this.ActivatedRoute.params.subscribe((parameter) => {
			if (parameter && parameter.searchText && parameter.searchText.length > 3) {
				this.searchText = parameter.searchText;
				this.search(0, '');
			} else {
				//Busca menor que 3
				this.NotificationService.setNotificationMessage(this.labels.lbl_min_char_search);
				this.isLoadingSearchtool = false;
			}
		});
	}

	changeSort(sortedBy: string): void {
		if (this.sortedBy == sortedBy) {
			this.sortDown = !this.sortDown;
			this.selectedPage = 1;
			this.search(0, this.selectedSearchType);
		} else {
			this.sortedBy = sortedBy;
			this.sortDown = true;
			this.selectedPage = 1;
			this.search(0, this.selectedSearchType);
		}
	}

	search(page: number, searchType: string) {
		if (this.searchReq) this.searchReq.unsubscribe();

		this.isLoadingNextPage = true;
		this.notFound = false;

		this.searchReq = this.SearchToolService.search(
			this.searchText,
			page,
			searchType,
			this.itemsPerPage,
			this.sortedBy,
			this.sortDown
		).subscribe({
			next: (search) => {
				if (search.cmdb.length === 0 && search.kb.length === 0 && search.request.length === 0) {
					this.isLoadingNextPage = false;
					this.isLoadingSearchtool = false;
					this.notFound = true;
				}
				if (searchType == '') {
					if (search.cmdb.length > 0) {
						this.selectedSearchType = 'cmdb';
						this.itemsPerType.cmdb = search.cmdb.length;
					}
					if (search.kb.length > 0) {
						this.selectedSearchType = 'kb';
						this.itemsPerType.kb = search.kb.length;
					}
					if (search.request.length > 0) {
						this.selectedSearchType = 'request';
						this.itemsPerType.request = search.request.length;
					}
					this.searchI = search;
				} else {
					this.searchI[searchType] = search[searchType];
				}
			},
			error: () => {
				this.notFound = true;
			},
		});

		this.searchReq.add(() => {
			this.isLoadingNextPage = false;
			this.isLoadingSearchtool = false;
		});
	}
}
